import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import ItemTabs from 'components/ItemTabs'
import MainData from './MainData'
import Address from './Address'
import Catalog from './Catalog'
import SocialMedias from './SocialMedias'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { Container } from '../styles'

export default function EditBusinessData () {
  const [loading, setLoading] = useState (true)
  const [business, setBusiness] = useState (null)
  const [socialMedias, setSocialMedias] = useState ([])
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  const updateBusinessData = updatedData => {
    setBusiness (prev => ({
      ...prev,
      ...updatedData,
      ...updatedData.address && {
        addresses: business.addresses.map (addr => (
          addr.id === updatedData.address.id ? updatedData.address : addr
        ))
      }
    }))
  }

  const TAB_LIST = [
    {
      label: 'Dados do salão',
      value: 'business_data',
      component: <MainData
        business={business}
        requestConfig={requestConfig}
        onDataUpdated={updateBusinessData}
      />
    },
    {
      label: 'Endereço',
      value: 'address',
      component: <Address
        business={business}
        requestConfig={requestConfig}
        onDataUpdated={updateBusinessData}
      />
    },
    {
      label: 'Catálogo',
      value: 'catalog',
      component: <Catalog
        businessId={businessId}
        requestConfig={requestConfig}
      />
    },
    {
      label: 'Redes sociais',
      value: 'social_medias',
      component: <SocialMedias
        businessId={businessId}
        socialMedias={socialMedias}
        businessSocialMedias={business?.social_medias}
        requestConfig={requestConfig}
        onDataUpdated={updateBusinessData}
      />
    }
  ]

  const [selectedTab, setSelectedTab] = useState (TAB_LIST[0].value)

  useEffect (() => {
    getData ()
  }, [])

  const getData = async () => {
    try {
      const [ { data: business }, { data: socialMedias }] = await Promise.all ([
        cutileiApi.get (`/businesses/${businessId}`),
        cutileiApi.get ('/social_medias'),
      ])

      setBusiness (business)
      setSocialMedias (socialMedias)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  if (loading) return <Loading style={{marginTop: 20}}/>

  return (
    <Container style={{paddingTop: 7}}>
      <ItemTabs
        tabs={TAB_LIST}
        selectedTab={selectedTab}
        onTabChange={setSelectedTab}
        containerStyle={{paddingTop: 0, marginBottom: 10}}
      />
      {TAB_LIST.find (tab => tab.value === selectedTab).component}
    </Container>
  )
}
